<template>
	
<core-card-foot-stat :value="value" :text="field.label" :raw="true" :invalid="value === 0" />

</template>

<script>

import wNumb from 'wnumb'

export default {

	props: ['item', 'field'],

	computed: {

		value: function() {

			return wNumb({
				'decimals': 2
			}).to(this.item.game.weight_avg)

		}

	}

}

</script>

<style scoped>

</style>
